import { CircleAlert, RotateCcw } from "lucide-react";
import type { ReactNode } from "react";
import { useSiteCopy } from "../i18n/useSiteCopy.ts";
import { Button } from "../ui/Button.tsx";

/** Load failure with a retry button. */
export const ErrorState = ({ onRetry }: { onRetry: () => void }): ReactNode => {
  const { common } = useSiteCopy();
  return (
    <div
      role="alert"
      className="mx-auto flex max-w-xl flex-col items-center gap-3 px-4 py-16 text-center">
      <CircleAlert aria-hidden="true" className="size-10 text-danger" />
      <h1 className="text-3xl font-semibold">{common.errorTitle}</h1>
      <p className="text-muted-foreground">{common.errorBody}</p>
      <Button variant="secondary" className="mt-2" onClick={onRetry}>
        <RotateCcw aria-hidden="true" className="size-4" />
        {common.retry}
      </Button>
    </div>
  );
};
